/* ============================================================
   GONG Collection — logique JS de la Grille Produits GONG
   Externalisé depuis sections/z-collectionproduittri.liquid.
   Wishlist + tiroir de filtres + traduction FR + accordéons.
   ============================================================ */
(function() {
  // ── Wishlist — même clé mz_wishlist que collection-sidebar ──
  var WL_KEY = 'mz_wishlist';
  function getWL() {
    try { return JSON.parse(localStorage.getItem(WL_KEY) || '[]'); } catch (e) { return []; }
  }
  function saveWL(arr) { localStorage.setItem(WL_KEY, JSON.stringify(arr)); }

  if (!window.mzToggleWish) {
    window.mzToggleWish = function(btn) {
      var handle = btn.getAttribute('data-handle');
      if (!handle) return;
      var wl  = getWL();
      var idx = wl.findIndex(function(p) { return p.handle === handle; });
      if (idx > -1) {
        wl.splice(idx, 1);
        btn.classList.remove('is-liked');
      } else {
        wl.push({
          handle:        handle,
          title:         btn.getAttribute('data-title'),
          image:         btn.getAttribute('data-image'),
          price:         parseInt(btn.getAttribute('data-price'), 10),
          variant_title: ''
        });
        btn.classList.add('is-liked');
      }
      saveWL(wl);
      btn.classList.remove('pop');
      void btn.offsetWidth;
      btn.classList.add('pop');
      window.dispatchEvent(new CustomEvent('mz:wishlist:updated', {
        detail: { handle: handle, added: btn.classList.contains('is-liked') }
      }));
    };
  }

  // ── Filter Drawer ──
  window.gpgOpenFilter = function() {
    document.getElementById('gpg-filter-drawer').classList.add('open');
    document.getElementById('gpg-filter-overlay').classList.add('open');
    document.body.style.overflow = 'hidden';
  };
  window.gpgCloseFilter = function() {
    document.getElementById('gpg-filter-drawer').classList.remove('open');
    document.getElementById('gpg-filter-overlay').classList.remove('open');
    document.body.style.overflow = '';
  };

  // ── Traduction labels filtres Shopify (anglais → français) ──
  var gpgFilterLabels = {
    'Availability': 'Disponibilité',
    'availability': 'Disponibilité',
    'AVAILABILITY': 'DISPONIBILITÉ',
    'Price': 'Prix',
    'price': 'Prix',
    'PRICE': 'PRIX',
    'In stock': 'En stock',
    'Out of stock': 'Hors stock',
    'Brand': 'Marque',
    'BRAND': 'MARQUE',
    'Color': 'Couleur',
    'COLOR': 'COULEUR',
    'Size': 'Taille',
    'SIZE': 'TAILLE',
    'Type': 'Type',
    'TYPE': 'TYPE',
    'Featured': 'En vedette',
    'Most relevant': 'Le plus pertinent',
    'Best selling': 'Meilleures ventes',
    'Alphabetically, A-Z': 'Alphabétique, A-Z',
    'Alphabetically, Z-A': 'Alphabétique, Z-A',
    'Price, low to high': 'Prix croissant',
    'Price, high to low': 'Prix décroissant',
    'Date, old to new': 'Date croissante',
    'Date, new to old': 'Date décroissante'
  };
  function gpgTranslate() {
    document.querySelectorAll('.gpg-filter-group__header span').forEach(function(el) {
      var t = el.textContent.trim();
      if (gpgFilterLabels[t]) el.textContent = gpgFilterLabels[t];
    });
    document.querySelectorAll('.gpg-filter-checkbox__label').forEach(function(el) {
      var t = el.textContent.trim();
      if (gpgFilterLabels[t]) el.textContent = gpgFilterLabels[t];
    });
    document.querySelectorAll('.gpg__sort-select option, .gpg-filter-sort__select option').forEach(function(el) {
      var t = el.textContent.trim();
      if (gpgFilterLabels[t]) el.textContent = gpgFilterLabels[t];
    });
  }
  document.addEventListener('DOMContentLoaded', gpgTranslate);

  // ── Filter Groups toggle ──
  window.gpgToggleGroup = function(id) {
    var group = document.getElementById('gpg-group-' + id);
    if (!group) return;
    var body  = group.querySelector('.gpg-filter-group__body');
    var btn   = group.querySelector('.gpg-filter-group__header');
    var isOpen = group.classList.contains('open');
    if (isOpen) {
      group.classList.remove('open');
      body.style.display = 'none';
      btn.setAttribute('aria-expanded', 'false');
    } else {
      group.classList.add('open');
      body.style.display = 'block';
      btn.setAttribute('aria-expanded', 'true');
    }
  };
})();



/* ============================================================
   GONG Résultats Collection — section « gongc »
   Bloc AJOUTÉ le 2026-07-24. Déplace les tuiles média de la
   réserve [data-gongc-store] aux deux extrémités de la grille
   produits .gpg__grid, et branche les pilules filtre sur le
   tiroir gpg déjà présent. N'altère pas la logique .gpg ci-dessus.
   ============================================================ */
(function(){
  function findGrid(){
    return document.querySelector('.gpg__grid')
        || document.querySelector('#product-grid')
        || document.querySelector('.product-grid')
        || document.querySelector('ul.grid__wrapper')
        || null;
  }
  function placeTiles(section){
    if (section.getAttribute('data-gongc-done') === '1') return;
    var store = section.querySelector('[data-gongc-store]');
    if (!store) { section.setAttribute('data-gongc-done','1'); return; }
    var tiles = Array.prototype.slice.call(store.querySelectorAll('[data-gongc-tile]'));
    if (!tiles.length) { section.setAttribute('data-gongc-done','1'); return; }
    var grid = findGrid();
    if (!grid) return; // grille pas encore rendue : nouvel essai plus tard
    tiles.forEach(function(tile, i){
      tile.hidden = false;
      tile.removeAttribute('aria-hidden');
      if (i === 0) {
        grid.insertBefore(tile, grid.firstElementChild); // 1re colonne / haut-gauche
      } else {
        grid.appendChild(tile); // dernière colonne / plus bas
      }
    });
    if (store.parentNode) store.parentNode.removeChild(store);
    section.setAttribute('data-gongc-done','1');
  }
  function wireFilters(section){
    var btns = section.querySelectorAll('[data-gongc-filter]');
    Array.prototype.forEach.call(btns, function(btn){
      if (btn.__gongcWired) return;
      btn.__gongcWired = true;
      btn.addEventListener('click', function(e){
        e.preventDefault();
        if (typeof window.gpgOpenFilter === 'function') window.gpgOpenFilter();
      });
    });
  }
  function run(){
    var sections = document.querySelectorAll('[data-gongc]');
    Array.prototype.forEach.call(sections, function(section){
      wireFilters(section);
      placeTiles(section);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else { run(); }
  // Filet de sécurité : la grille peut arriver après (paginate / rendu asynchrone)
  var tries = 0;
  var iv = setInterval(function(){
    tries++;
    var pending = document.querySelector('[data-gongc]:not([data-gongc-done])');
    if (!pending || tries > 20) { clearInterval(iv); return; }
    run();
  }, 250);
  // Éditeur de thème Shopify
  document.addEventListener('shopify:section:load', run);
})();
